/**
 * Configuración centralizada de API Keys por módulo
 * Cada módulo del backend tiene su propia API key para autenticación
 */

export const API_KEYS = {
    forms: import.meta.env.VITE_FORMS_API_KEY || 'formsApiKey',
    auth: import.meta.env.VITE_AUTH_API_KEY || 'authApiKey',
    admissions: import.meta.env.VITE_ADMISSIONS_API_KEY || 'admissionsApiKey',
    enrollments: import.meta.env.VITE_ENROLLMENTS_API_KEY || 'enrollmentsApiKey',
    surveys: import.meta.env.VITE_SURVEYS_API_KEY || 'surveysApiKey',
} as const;

export type ModuleName = keyof typeof API_KEYS;

/**
 * Obtiene la API key para un módulo específico
 */
export function getApiKey(module: ModuleName): string {
    return API_KEYS[module];
}
